import { useMutation, useQueryClient } from "react-query";
import { toast } from 'react-toastify';
import { SrxApi } from '../api/SrxApi';

const useCreateVersion = (setSelectedVersion, setIsModalOpen) => {
  const queryClient = useQueryClient();

  const { mutate: addVersion, isLoading } = useMutation(
    async ({ payload }) => {
      const response = await SrxApi.post(`/versions/create-or-edit`, payload);
      return response?.data;
    },
    {
      onSuccess: (data) => {
        if (data) {
          setSelectedVersion(null);
          setIsModalOpen(false);
          toast.success(data?.message || "Version added successfully!");
          queryClient.invalidateQueries(["getAllVersion"]);
          queryClient.invalidateQueries(["currentVersion"]);
        }
      },
      onError: (error) => {
        const errorMessage = error?.response?.data?.message || error?.message || "Failed to add version";
        toast.error(errorMessage);
      },
    }
  );

  return { addVersion, isAddVersionLoading: isLoading };
};

export default useCreateVersion;